/* THIS FILE IS GENERATED BY BrowserEventTypeScriptGenerator. */
import { browserEvent, browserEventChannel } from './browser-event'
import type { IAgentBrowserEvents } from '../signalr/generated/TypedSignalR.Client/Platform.AgentIntegration.Agents.AgentRegistered.BrowserEvents'
import type { AgentPskBrowserEventChannel } from '../signalr/generated/Platform.AgentIntegration.Agents.AgentRegistered.BrowserEvents'
import type { IDiscoveryProgressBrowserEvents } from '../signalr/generated/TypedSignalR.Client/Platform.AgentIntegration.DiscoveryProgress.BrowserEvents'
import type { DiscoveryProgressBrowserEventChannel } from '../signalr/generated/Platform.AgentIntegration.DiscoveryProgress.BrowserEvents'
import type { IPackageSourceBrowserEvents } from '../signalr/generated/TypedSignalR.Client/Platform.AgentIntegration.Packages.Sources.BrowserEvents'
import type { PackageSourceBrowserEventChannel } from '../signalr/generated/Platform.AgentIntegration.Packages.Sources.BrowserEvents'
import type { IHierarchyBrowserEvents } from '../signalr/generated/TypedSignalR.Client/Platform.Hierarchy.BrowserEvents'
import type { EntityBrowserEventChannel } from '../signalr/generated/Platform.Hierarchy.BrowserEvents'
import type { IIdentityBrowserEvents } from '../signalr/generated/TypedSignalR.Client/Platform.Identity.BrowserEvents'
import type { INotificationBrowserEvents } from '../signalr/generated/TypedSignalR.Client/Platform.Notification.Contracts.BrowserEvents'
import type { IPolicyBrowserEvents } from '../signalr/generated/TypedSignalR.Client/Platform.Policy.BrowserEvents'
import type { PolicyBrowserEventChannel } from '../signalr/generated/Platform.Policy.BrowserEvents'
import type { IWorkflowRunBrowserEvents } from '../signalr/generated/TypedSignalR.Client/Platform.Workflow.Runs.BrowserEvents'
import type { WorkflowRunBrowserEventChannel } from '../signalr/generated/Platform.Workflow.Runs.BrowserEvents'

export const AgentBrowserEvents = {
  for(channel: AgentPskBrowserEventChannel) {
    const address = browserEventChannel('Platform.AgentIntegration.Agents.AgentRegistered.BrowserEvents.AgentPskBrowserEventChannel', channel)
    return {
      agentRegistered: browserEvent<Parameters<IAgentBrowserEvents['agentRegistered']>>(
        'Platform.AgentIntegration.Agents.AgentRegistered.BrowserEvents.IAgentBrowserEvents',
        'AgentRegistered',
        address,
      ),
    }
  },
} as const

export const DiscoveryProgressBrowserEvents = {
  for(channel: DiscoveryProgressBrowserEventChannel) {
    const address = browserEventChannel('Platform.AgentIntegration.DiscoveryProgress.BrowserEvents.DiscoveryProgressBrowserEventChannel', channel)
    return {
      discoveryProgressChanged: browserEvent<Parameters<IDiscoveryProgressBrowserEvents['discoveryProgressChanged']>>(
        'Platform.AgentIntegration.DiscoveryProgress.BrowserEvents.IDiscoveryProgressBrowserEvents',
        'DiscoveryProgressChanged',
        address,
      ),
    }
  },
} as const

export const PackageSourceBrowserEvents = {
  for(channel: PackageSourceBrowserEventChannel) {
    const address = browserEventChannel('Platform.AgentIntegration.Packages.Sources.BrowserEvents.PackageSourceBrowserEventChannel', channel)
    return {
      changed: browserEvent<Parameters<IPackageSourceBrowserEvents['changed']>>(
        'Platform.AgentIntegration.Packages.Sources.BrowserEvents.IPackageSourceBrowserEvents',
        'Changed',
        address,
      ),
    }
  },
} as const

export const HierarchyBrowserEvents = {
  for(channel: EntityBrowserEventChannel) {
    const address = browserEventChannel('Platform.Hierarchy.BrowserEvents.EntityBrowserEventChannel', channel)
    return {
      capabilitiesChanged: browserEvent<Parameters<IHierarchyBrowserEvents['capabilitiesChanged']>>(
        'Platform.Hierarchy.BrowserEvents.IHierarchyBrowserEvents',
        'CapabilitiesChanged',
        address,
      ),
      entityChanged: browserEvent<Parameters<IHierarchyBrowserEvents['entityChanged']>>(
        'Platform.Hierarchy.BrowserEvents.IHierarchyBrowserEvents',
        'EntityChanged',
        address,
      ),
    }
  },
} as const

export const IdentityBrowserEvents = {
  permissionsChanged: browserEvent<Parameters<IIdentityBrowserEvents['permissionsChanged']>>(
    'Platform.Identity.BrowserEvents.IIdentityBrowserEvents',
    'PermissionsChanged',
    undefined,
  ),
} as const

export const NotificationBrowserEvents = {
  notificationsChanged: browserEvent<Parameters<INotificationBrowserEvents['notificationsChanged']>>(
    'Platform.Notification.Contracts.BrowserEvents.INotificationBrowserEvents',
    'NotificationsChanged',
    undefined,
  ),
} as const

export const PolicyBrowserEvents = {
  for(channel: PolicyBrowserEventChannel) {
    const address = browserEventChannel('Platform.Policy.BrowserEvents.PolicyBrowserEventChannel', channel)
    return {
      changed: browserEvent<Parameters<IPolicyBrowserEvents['changed']>>(
        'Platform.Policy.BrowserEvents.IPolicyBrowserEvents',
        'Changed',
        address,
      ),
    }
  },
} as const

export const WorkflowRunBrowserEvents = {
  for(channel: WorkflowRunBrowserEventChannel) {
    const address = browserEventChannel('Platform.Workflow.Runs.BrowserEvents.WorkflowRunBrowserEventChannel', channel)
    return {
      changed: browserEvent<Parameters<IWorkflowRunBrowserEvents['changed']>>(
        'Platform.Workflow.Runs.BrowserEvents.IWorkflowRunBrowserEvents',
        'Changed',
        address,
      ),
    }
  },
} as const
